const deleteConnection = (id) => `mutation MyMutation {
  deleteContact(input: {id: "${id}"}) {
    status
  }
}`;
// a749bf95-77c0-4178-b7ac-5bb78f1e137d#e93e7489-37ea-4b52-848b-a49b7f1ef6ab
export default deleteConnection;